import FormResource from "@/module/Form/Resources/FormResource";

export default class FapiTwisto {
  private formResource: FormResource;
  private initialized: boolean = false;

  constructor(formResource: FormResource) {
    this.formResource = formResource;
  }

  init() {
    if (this.formResource.twisto_public_key === undefined || this.initialized) {
      return;
    }

    this.initialized = true;

    const _twisto_config = {
      public_key: this.formResource.twisto_public_key,
      script: "https://api.twisto.cz/v2/lib/twisto.js",
    };

    (function (e: any, g: any, a: any) {
      function h(a: any) {
        return function (...args: any) {
          b._.push([a, args]);
        };
      }

      const f = ["check"],
        b = e || {},
        c = document.createElement(a);
      a = document.getElementsByTagName(a)[0];
      b._ = [];
      for (let d = 0; d < f.length; d++) b[f[d]] = h(f[d]);
      // @ts-ignore
      this[g] = b;
      c.type = "text/javascript";
      c.async = !0;
      c.src = e.script;
      c.onload = a.parentNode.insertBefore(c, a);
      delete e.script;
    }).call(window, _twisto_config, "Twisto", "script");
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  check(twistoData: any, payload: any, resolve: (payload: any) => void): void {
    // @ts-ignore
    Twisto.check(
      twistoData,
      (response: any) => {
        payload.next_url =
          payload.next_url +
          "&twistoTransactionId=" +
          response.transaction_id +
          "&state=" +
          response.status;

        resolve(payload);
      },
      () => {
        return resolve(payload);
      },
    );
  }
}
